// import {Analytics, GoogleAnalytics, LinkedInInsight, GoogleAnalyticsEventObserver, GoogleAnalyticsPageviewObserver} from '@plaudit/analytics';

// const analytics = Analytics.getInstance();
// const googleAnalytics = analytics.getTracker(GoogleAnalytics.platformName) as GoogleAnalytics;
// const linkedInInsight = analytics.getTracker(LinkedInInsight.platformName) as LinkedInInsight;

// if (googleAnalytics !== null) {
// 	googleAnalytics.addHitObserver(
// 		new GoogleAnalyticsPageviewObserver(
// 			() => {
// 				if (linkedInInsight !== null) linkedInInsight.trackConversion(5354330);
// 			},
// 			{
// 				pagePath:	(value: string) => value.indexOf("/contact-success.html") === 0
// 			}
// 		)
// 	);

// 	googleAnalytics.addHitObserver(
// 		new GoogleAnalyticsEventObserver(
// 			() => {
// 				if (linkedInInsight !== null) linkedInInsight.trackConversion(4692498);
// 			},
// 			{
// 				eventCategory:	(value: string) => value === "JSF Action",
// 				eventAction:	(value: string) => value.indexOf("$questionnaire.submit") != -1,
// 				eventLabel:	(value: string) => value === "success"
// 			}
// 		)
// 	);
// }

import {Analytics, GTag, GTagEventObserver, GTagPageviewObserver} from '@plaudit/analytics';
import FacebookPixel from "@plaudit/analytics/dist/tracker/FacebookPixel";

Analytics.setup({features: {errorTracking: false}});

const gtag = GTag.getInstance();
const facebookPixel = FacebookPixel.getInstance();

if (gtag !== null) {
	gtag.addObserver(
		
		new GTagPageviewObserver(
			{
				pagePath: (value: string) => {
					return value === "/contact-success" // Contact Form
				}
			},
			() => {
				if (facebookPixel !== null) facebookPixel.trackEventLead({ value: 500 });
			}
		)
	);
	
	gtag.addObserver(
		new GTagEventObserver(
			{
				// Email or Telephone Click
				eventCategory: (value: string) => value === "Email Link" || value === "Telephone Link",
				eventAction: (value: string) => value === "Click"
			},
			() => {
				if (facebookPixel !== null) facebookPixel.trackEventLead({ value: 250 });
			},
		)
	);
}
